import type { UnknownAction, Reducer } from '@reduxjs/toolkit';

/**
 * mergeReducer
 * @param reducer1
 * @param reducer2
 */
export const mergeReducer =
  <
    R1 extends Reducer,
    R2 extends Reducer,
    MS extends ReturnType<R1> & ReturnType<R2>,
  >(
    reducer1: R1,
    reducer2: R2
  ): Reducer<MS> =>
  (state: MS | undefined, action: UnknownAction) => {
    return reducer2(reducer1(state, action), action);
  };
